/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateSageIntacctProjectInput = {
    name?: string | null | undefined;
    projectCategory?: string | null | undefined;
    clientId?: string | null | undefined;
    locationId?: string | null | undefined;
    forecastProjectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateSageIntacctProjectMutationVariables = {
    input: CreateSageIntacctProjectInput;
};
export type CreateSageIntacctProjectMutationResponse = {
    readonly createSageIntacctProject: {
        readonly project: {
            readonly id: string;
            readonly name: string | null;
            readonly sageProject: {
                readonly sageProjectId: string | null;
            } | null;
        } | null;
    } | null;
};
export type CreateSageIntacctProjectMutation = {
    readonly response: CreateSageIntacctProjectMutationResponse;
    readonly variables: CreateSageIntacctProjectMutationVariables;
};



/*
mutation CreateSageIntacctProjectMutation(
  $input: CreateSageIntacctProjectInput!
) {
  createSageIntacctProject(input: $input) {
    project {
      id
      name
      sageProject {
        sageProjectId
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSageIntacctProjectInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageProjectId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSageIntacctProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSageIntacctProjectPayload",
        "kind": "LinkedField",
        "name": "createSageIntacctProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SageProjectType",
                "kind": "LinkedField",
                "name": "sageProject",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSageIntacctProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSageIntacctProjectPayload",
        "kind": "LinkedField",
        "name": "createSageIntacctProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SageProjectType",
                "kind": "LinkedField",
                "name": "sageProject",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateSageIntacctProjectMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSageIntacctProjectMutation(\n  $input: CreateSageIntacctProjectInput!\n) {\n  createSageIntacctProject(input: $input) {\n    project {\n      id\n      name\n      sageProject {\n        sageProjectId\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c0749dab26f885f2a50e9f5b862ee573';
export default node;
